/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const it_root_enrollment_open_until = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Iscrizioni aperte fino al ${i.date}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "it" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const root_enrollment_open_until = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.root_enrollment_open_until(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("root_enrollment_open_until", locale)
	return it_root_enrollment_open_until(inputs)
};
export { root_enrollment_open_until as "root.enrollment-open-until" }